/**
 *  urlApi.js
 *  @version: 1.0.0
 *  @author: DWIT MÉXICO
 *  @description: Manejor de las ruta directas al API
 */

// la empresa DWIT MÉXICO para este proyecto eleva tiene 3 ambientes de desarrollo y se negaron a usar variables de entorno
function getURL() {
   // REACT_APP_API_URL manda si viene (p. ej. el build de prueba contra
   // api-v1); si no, se queda la lógica de siempre.
   const override = process?.env?.REACT_APP_API_URL;
   if (override) return override.endsWith('/') ? override : `${override}/`;
   const env = process?.env?.REACT_APP_ENV;
   if (env === 'development') {
      // return 'https://testeleva.azurewebsites.net/';
      return 'http://localhost:8080/';
   } else {
      return 'https://api-customerservice.elevacap.com/';
   }
}

export const URL_API = getURL();
